<ul class="breadcrums list-inline d-flex gap-2 p-0" *transloco="let t; read: 'breadCrumb'">
  @for (menu of data; track $index; let i = $index, last = $last) {
  <li>
    <a [routerLink]="menu.url" [ngClass]="{'active':last}">{{ menu.translate ? t(menu.translate) : menu.name }}</a>
    @if(!last){
    <i class="fa-solid" [class.fa-angle-right]="!isRtl()" [class.fa-angle-left]="isRtl()"></i>
    }
  </li>
  }
</ul>
